import { AnimalEmoji } from '@quicktools/shared-components/components/core/svgicons';
import IconHeartsSimilar from '@picsart/icons/IconHeartsSimilar';
import IconFaceTool from '@picsart/icons/IconFaceTool';
import {
  activity,
  animalsAndNature,
  flags,
  foodAndDrink,
  objects,
  smileysAndPeople,
  symbols,
  travelAndPlaces,
} from '@quicktools/emojis/data';

import { emojiPageId, categoryPageId, PAGE_TYPE } from './pageIds';

export const icons = {
  [emojiPageId.redHeart]: IconHeartsSimilar,
  [emojiPageId.star]: AnimalEmoji,
  [emojiPageId.christmasTree]: AnimalEmoji,
  [emojiPageId.meltingFace]: IconFaceTool,
  [emojiPageId.eyes]: IconFaceTool,
  [emojiPageId.huggingFace]: IconFaceTool,
  [emojiPageId.thumbsUp]: IconFaceTool,
  [emojiPageId.flushedFace]: IconFaceTool,
  [emojiPageId.fire]: AnimalEmoji,
  [emojiPageId.zzz]: IconHeartsSimilar,
};

export const emojisByCategory = {
  [categoryPageId.activities]: activity,
  [categoryPageId.nature]: animalsAndNature,
  [categoryPageId.foodDrink]: foodAndDrink,
  [categoryPageId.objects]: objects,
  [categoryPageId.symbols]: symbols,
  [categoryPageId.travelPlaces]: travelAndPlaces,
  [categoryPageId.flags]: flags,
  [categoryPageId.people]: smileysAndPeople,
};

export const emojiPageData = {
  [emojiPageId.redHeart]: {
    glyph: '❤️',
    name: 'red heart',
    categoryId: categoryPageId.nature,
    paragraphs: 3,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.star]: {
    glyph: '⭐',
    name: 'star',
    categoryId: categoryPageId.symbols,
    paragraphs: 3,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.christmasTree]: {
    glyph: '🎄',
    name: 'christmas tree',
    categoryId: categoryPageId.nature,
    paragraphs: 3,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.meltingFace]: {
    glyph: '🫠',
    name: 'melting face',
    categoryId: categoryPageId.people,
    paragraphs: 2,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.eyes]: {
    glyph: '👀',
    name: 'eyes',
    categoryId: categoryPageId.people,
    paragraphs: 2,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.huggingFace]: {
    glyph: '🤗',
    name: 'hugging face',
    categoryId: categoryPageId.people,
    paragraphs: 3,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.thumbsUp]: {
    glyph: '👍',
    name: 'thumbs up',
    categoryId: categoryPageId.people,
    paragraphs: 3,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.flushedFace]: {
    glyph: '😳',
    name: 'flushed face',
    categoryId: categoryPageId.people,
    paragraphs: 3,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.fire]: {
    glyph: '🔥',
    name: 'fire',
    categoryId: categoryPageId.nature,
    paragraphs: 4,
    type: PAGE_TYPE.emoji,
  },

  [emojiPageId.zzz]: {
    glyph: '💤',
    name: 'zzz',
    categoryId: categoryPageId.symbols,
    paragraphs: 3,
    type: PAGE_TYPE.emoji,
  },
};

export const categoryPageData = {
  [categoryPageId.people]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/95550554311063764581.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/02885132936451151093.webp',
        width: 464,
        height: 335,
      },
      {
        url: 'https://cdn140.picsart.com/77058107953419453371.webp',
        width: 464,
        height: 335,
      },
      {
        url: 'https://cdn140.picsart.com/34619202938556000089.webp',
        width: 464,
        height: 335,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.nature]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/00843033311049637382.webp',
        width: 413,
        height: 274,
      },
      {
        url: 'https://cdn140.picsart.com/21427912379916557710.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.foodDrink]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/57083198806822280478.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/00378110809140372395.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.activities]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/62008488005687167628.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/06538842999805941467.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.travelPlaces]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/64484382491175964429.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/29348090515719279496.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.objects]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/58300407818442165764.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/08938565081617451690.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.symbols]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/97525528389546286901.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/12171666913546760025.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.flags]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/90832895792951099417.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
};
